import {FC, useState} from 'react';
import {useRecoilValue} from 'recoil';

import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import {Button, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import {green} from '@mui/material/colors';

import {buttonStyle} from '../../../../shared/styles';
import {AddDelay} from './AddDelay';

import {currentServiceRequestState} from '../../../../store/service-requests/atoms';

import {IServiceRequest} from '../../../../shared/types/serviceRequest.types';
import {authState} from '../../../../store/auth/atoms';
import {TypeAccountRoles} from '../../../../shared/types/user-account.types';

export const TableToolbar: FC = () => {
  const serviceRequest = useRecoilValue(currentServiceRequestState) as IServiceRequest;
  const [open, setOpen] = useState(false);
  const {user} = useRecoilValue(authState);

  const isCustomer = user?.roles?.filter((i) => i !== TypeAccountRoles.CUSTOMER).length === 1;

  console.log(
    isCustomer,
    !isCustomer && (serviceRequest.statusCode === 'READY_TO_PROCESS' || serviceRequest.statusCode === 'DELAYED'),
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Toolbar
        sx={{
          pl: {sm: 2},
          pr: {xs: 1, sm: 1},
          justifyContent: 'space-between',
        }}
      >
        <Stack direction="column" width="100%" spacing={1}>
          <Stack direction="row" paddingY={2} justifyContent="space-between">
            <Typography variant="subtitle1">Учет недопусков</Typography>
            {!isCustomer &&
            (serviceRequest.statusCode === 'READY_TO_PROCESS' || serviceRequest.statusCode === 'DELAYED') ? (
              <Button
                sx={{
                  ...buttonStyle,
                  p: 1,
                  border: 0,
                  height: 30,
                  background: green[500],
                  '&:hover': {
                    background: green[600],
                    border: 0,
                  },
                }}
                onClick={handleOpen}
                startIcon={<AddIcon htmlColor="#fff" />}
                variant="outlined"
              >
                <Typography variant="subtitle2" sx={{color: '#fff'}}>
                  Добавить недопуск
                </Typography>
              </Button>
            ) : null}
          </Stack>
        </Stack>
      </Toolbar>
      <AddDelay open={open} handleClose={handleClose} />
    </>
  );
};
